import { Route, useNavigate } from "react-router";

import { RoutesWithNotFound } from "@/components";
import { PathNamekRoutes } from "@/router";
import { GuardRoute } from "@/features/auth";
import { ConfigPermission } from "@/config/models";

import { Materials } from "../modules/materials";
import { AssignMaterials } from "../modules/assignMaterials";

export default function ConfigRoutes() {
  const navigate = useNavigate();

  const navigateToInit = () => {
    navigate(`/${PathNamekRoutes.WELCOME}`, { replace: true });
  };

  return (
    <RoutesWithNotFound onBack={() => navigateToInit()}>
      <Route
        element={
          <GuardRoute must={ConfigPermission.MATERIALS}>
            <Materials />
          </GuardRoute>
        }
        path={`${PathNamekRoutes.CONFIG.MATERIALS}/:edition?`}
      />
      <Route
        element={
          <GuardRoute must={ConfigPermission.ASSIGN_MATERIALS}>
            <AssignMaterials />
          </GuardRoute>
        }
        path={`${PathNamekRoutes.CONFIG.ASSIGN_MATERIALS}/:edition?`}
      />
    </RoutesWithNotFound>
  );
}
